import React from "react";

export const SignatureLineElement = data => (
  <div className="d-flex row w-100 signatureBlock">
    <div className="col-12 pb-2">
      <div className="d-flex justify-content-center ">
        <div className="signatureLine" />
      </div>
    </div>
    <div className={` col-12 ${data.className || ""}`}>
      <div className="d-flex justify-content-center ">
        <p>{data.text}</p>
      </div>
    </div>
  </div>
);

export const SignatureDivElement = (data, title) => (
  <div className="p-3 avoidPageBreakInside">
    {title && (
      <div className="pl-5 pb-3 eb_fs_20">
        <b>{title}</b>
      </div>
    )}
    <div className="row">
      <div className="col-12 px-5 py-3 signatureBorder">
        <b>{data.mainText}</b>
      </div>
      <div className="col-6 "></div>
      <div className="col-6 p-3 signatureBorder2 signatureDiv">{data.signatureText}</div>
    </div>
  </div>
);
